import React from "react";
import { Loader } from "@mantine/core";

const LoaderComp = ({ size }) => {
  return <Loader size={size} />;
};

export default LoaderComp;
